import { Component, OnInit } from '@angular/core';
import { forkJoin } from 'rxjs';
import Swal from 'sweetalert2';
import { SupplyService } from '../supply.service';

@Component({
  selector: 'app-supply-history-analytics',
  templateUrl: './supply-history-analytics.component.html',
  styleUrls: ['./supply-history-analytics.component.scss']
})
export class SupplyHistoryAnalyticsComponent implements OnInit {
  loading = false;
  productTypes: any[] = [];
  productItems: any[] = [];
  rows: any[] = [];
  analytics: any = null;

  displayedColumns = [
    'dispatchDate',
    'product',
    'buyerName',
    'origin',
    'destination',
    'unitCount',
    'unitPrice',
    'commissionAmount',
    'totalAmount',
    'netAmount'
  ];

  filters: any = {
    from: '',
    to: '',
    productTypeId: null,
    productItemId: null,
    search: ''
  };

  constructor(private supplyService: SupplyService) {}

  ngOnInit(): void {
    this.loadProductFilters();
    this.runFilter();
  }

  loadProductFilters(): void {
    this.supplyService.getProducts().subscribe({
      next: (types) => {
        this.productTypes = types || [];
        this.bindItems();
      },
      error: (err) => Swal.fire('Error', err?.error?.message || 'Failed to load supply filters.', 'error')
    });
  }

  onTypeChange(): void {
    this.filters.productItemId = null;
    this.bindItems();
  }

  runFilter(): void {
    this.loading = true;
    const payload = {
      from: this.filters.from || undefined,
      to: this.filters.to || undefined,
      productTypeId: this.filters.productTypeId || null,
      productItemId: this.filters.productItemId || null,
      search: this.filters.search || undefined
    };

    forkJoin({
      rows: this.supplyService.getDispatches(payload),
      analytics: this.supplyService.getDispatchAnalytics(payload)
    }).subscribe({
      next: ({ rows, analytics }) => {
        this.rows = rows || [];
        this.analytics = analytics || null;
        this.loading = false;
      },
      error: (err) => {
        this.loading = false;
        Swal.fire('Error', err?.error?.message || 'Failed to load supply history.', 'error');
      }
    });
  }

  resetFilters(): void {
    this.filters = {
      from: '',
      to: '',
      productTypeId: null,
      productItemId: null,
      search: ''
    };
    this.productItems = [];
    this.runFilter();
  }

  private bindItems(): void {
    const selectedType = this.productTypes.find((t: any) => t.id === Number(this.filters.productTypeId));
    this.productItems = selectedType?.items || [];
  }
}
